import { PageTitle } from "../../components/Headers";
import { PageBody } from "../../components/PageBody";
import { Helmet } from "react-helmet-async";
import { GridDiv, GridDivContainer } from "../../components/GridDiv";
import { ProjectLink } from "../../components/ProjectLink";
import { ArticleParagraph } from "../../components/Paragraphs";
import { getProjectsForSection } from "../../config/projects";
import { getSEOForPath } from "../../config/seo";
import { useLocation } from "react-router-dom";

// Get sports models projects from centralized config
const sportsModelsProjects = getProjectsForSection('/sports-models');


export const SportsModelsHome = () => {
    const location = useLocation();
    const seo = getSEOForPath(location.pathname);
    
    return (
        <PageBody>
            <Helmet>
                <title>{seo.title}</title>
                <meta name="description" content={seo.description} />
                {seo.keywords && <meta name="keywords" content={seo.keywords} />}
                {seo.ogTitle && <meta property="og:title" content={seo.ogTitle} />}
                {seo.ogType && <meta property="og:type" content={seo.ogType} />}
                {seo.ogUrl && <meta property="og:url" content={seo.ogUrl} />}
                {seo.ogDescription && <meta property="og:description" content={seo.ogDescription} />}
            </Helmet>

            <PageTitle title="Predictive Sports Modelling" />

            <ArticleParagraph
                lines={[
                    "Interested in sports and sport statistics? You have probably thought about applying statistics to predict game outcomes. That can be as simple as studying the form of a team or whether a player has a good record against a team. This is fundamentally combining knowledge from statistics and historic events to make a guess, or prediction, about a future one. This type of information has become more mainstream in recent years and is part of the broadcasting of 'traditional' statistics such as shots on target.",
                    "Taking data and using machine learning and statistical modelling to do this is predictive sports modelling; it has applications for teams and recruitment as well as professional sports betting. Sports data is often held behind large paywalls and kept at a premium. Much of the work that you will see on this website uses the concepts of building out models that can be used to simulate sporting events and could easily be applied with access to the large historic data sets that exists for practically every sport at this point. The more granular the data, the more features that could be engineered and models built.",
                    "My english pool Monte Carlo simulation system, for example, builds out a version of the game programmatically to simulate the results between two fictional players. It does, however, use statistics (or player features) that could be recorded and calculated from real matches and 'plugged in' to the simulations to create a prediction of the results between those two players.",
                    "Variation of results is at the heart of sporting events so most models must account for this and take a probabilistic approach; Team A is X% likely to beat Team B. Simulating a sports model thousands of times can produce these probabilities and create a distribution of possible results that might occur. If you do this for every game, then you can do it for all the games in a league to try and pick the league winner."
                ]}
            />

            <GridDivContainer>
                {sportsModelsProjects.map((project) => (
                    <GridDiv
                        key={project.to}
                        widthClasses="w-full sm:w-1/2"
                    >
                        <ProjectLink
                            to={project.to}
                            title={project.title}
                            icon={project.icon}
                            colorClass={project.colorClass}
                        />
                    </GridDiv>
                ))}
            </GridDivContainer>
        </PageBody>
    );
};
